import {
  FileExcelOutlined,
  FileImageOutlined,
  FileOutlined,
  FilePdfOutlined,
  FileWordOutlined,
  FileZipOutlined,
  PlayCircleOutlined
} from "@ant-design/icons"
import React from "react"

const isImage = (mimeType?: string) => mimeType?.startsWith("image/")
const isVideo = (mimeType?: string) => mimeType?.startsWith("video/")
const isPdf = (mimeType?: string) => mimeType === "application/pdf"
const isWord = (mimeType?: string) =>
  mimeType?.includes("word") || mimeType?.includes("document")
const isExcel = (mimeType?: string) =>
  mimeType?.includes("excel") || mimeType?.includes("spreadsheet")
const isZip = (mimeType?: string) =>
  mimeType?.includes("zip") || mimeType?.includes("compressed")

const getFileIcon = (mimeType?: string) => {
  if (isPdf(mimeType))
    return <FilePdfOutlined className="text-3xl text-red-500" />
  if (isWord(mimeType))
    return <FileWordOutlined className="text-3xl text-blue-500" />
  if (isExcel(mimeType))
    return <FileExcelOutlined className="text-3xl text-green-500" />
  if (isZip(mimeType))
    return <FileZipOutlined className="text-3xl text-yellow-500" />
  if (isVideo(mimeType))
    return <PlayCircleOutlined className="text-3xl text-purple-500" />
  if (isImage(mimeType))
    return <FileImageOutlined className="text-3xl text-cyan-500" />
  return <FileOutlined className="text-3xl text-gray-400" />
}

const formatFileSize = (bytes?: number) => {
  if (!bytes) return ""
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}

export {
  getFileIcon,
  formatFileSize,
  isWord,
  isPdf,
  isExcel,
  isZip,
  isImage,
  isVideo
}
